import { Controller } from 'stimulus';

class PageSwitchController extends Controller {
  connect() {
    this.isPreloaded = false;
  }

  /**
   * @param {Event & { target: HTMLInputElement }} event
  */
  // eslint-disable-next-line class-methods-use-this
  onChange(event) {
    const { checked } = event.target;

    const url = event.target.dataset[checked ? 'checked' : 'unchecked'];

    event.target.disabled = true;

    setTimeout(() => {
      window.location.href = url;
    }, 250);
  }

  onMouseEnter() {
    const inverseChecked = !this.inputTarget.checked;

    const url = this.inputTarget.dataset[inverseChecked ? 'checked' : 'unchecked'];

    this.preloadPage(url);
  }

  preloadPage(url) {
    if (this.isPreloaded) {
      return;
    }

    const isSupported = document.createElement('link').relList.supports('prefetch');

    if (!isSupported) {
      return;
    }

    const linkElement = document.createElement('link');
    linkElement.rel = 'prefetch';
    linkElement.href = url;
    linkElement.as = 'document';
    linkElement.fetchPriority = 'auto';

    document.head.appendChild(linkElement);

    this.isPreloaded = true;
  }
}

PageSwitchController.targets = [
  'input',
];

export default PageSwitchController;
